/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const LocationIcon = /*#__PURE__*/ createSvgIcon(
  'LocationIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M10 16.02c1.653-1.485 2.9-2.853 3.74-4.103.84-1.25 1.26-2.368 1.26-3.354 0-1.459-.476-2.667-1.427-3.626C12.62 3.98 11.43 3.5 10 3.5c-1.43 0-2.622.48-3.573 1.438C5.476 5.896 5 7.104 5 8.563c0 .986.42 2.104 1.26 3.354.84 1.25 2.087 2.618 3.74 4.104zm0 1.5c-.18 0-.35-.03-.51-.093a1.751 1.751 0 01-.47-.281 34.82 34.82 0 01-1.801-1.709 19.436 19.436 0 01-1.802-2.104 12.382 12.382 0 01-1.375-2.343C3.68 10.177 3.5 9.368 3.5 8.562c0-1.86.618-3.42 1.854-4.677C6.59 2.628 8.14 2 10 2c1.847 0 3.392.628 4.635 1.885C15.88 5.142 16.5 6.701 16.5 8.563c0 .805-.184 1.618-.552 2.437a13.01 13.01 0 01-1.375 2.354 17.893 17.893 0 01-1.792 2.094 37.48 37.48 0 01-1.802 1.698c-.153.125-.309.219-.469.281-.16.063-.33.094-.51.094zM10 10c.417 0 .77-.146 1.063-.438.291-.291.437-.645.437-1.062 0-.417-.146-.77-.438-1.063A1.447 1.447 0 0010 7c-.417 0-.77.146-1.063.438A1.447 1.447 0 008.5 8.5c0 .417.146.77.438 1.063.291.291.645.437 1.062.437z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default LocationIcon;
